import { useEffect } from 'react';
import { useBookingContext } from '../../contexts/BookingContext';
import { formatFullDate } from '../../utils/dates';
import EditAppointmentButton from '../atoms/EditAppointmentButton';
import Heading from '../atoms/Heading';
import SubmitAppointmentButton from '../atoms/SubmitAppointmentButton';
import AppointmentInfo from '../molecules/AppointmentInfo';
import Container, { Wrapper } from '../organisms/Container';
import Navigation from '../organisms/Navigation';

interface ErrorProps {
	getLabel: (key: string) => string;
	message: string;
	detail?: string;
}

export default function Error({ getLabel, message, detail = '' }: ErrorProps) {
	const { appointment, availability, locale, timezone, setScene } = useBookingContext();

	useEffect(() => {
		setScene('error');
	}, []);

	return (
		<Container id="error">
			<Wrapper>
				<span className="error-icon"></span>
				<Heading title={message} subtitle={detail} />
				<AppointmentInfo
					heading={getLabel('appointment_info_next_available')}
					isLoading={!appointment.timeSlot && availability.isLoading}
					onClick={appointment.canBeEdited ? appointment.edit : undefined}
					timeSlotString={
						appointment.timeSlot ? formatFullDate(appointment.timeSlot.start_datetime, appointment.timeSlot.end_datetime, locale, timezone.current) : ''
					}
				>
					{appointment.canBeEdited && (
						<div className="appointment-info__change-btn">
							<EditAppointmentButton getLabel={getLabel} />
						</div>
					)}
				</AppointmentInfo>
			</Wrapper>

			<Navigation keyProp="error">
				<SubmitAppointmentButton getLabel={getLabel} />
			</Navigation>
		</Container>
	);
}
